import { styled } from '@/stitches.config';
import { ReactComponent as ColonIcon } from '@assets/colon-icon-with-circle.svg';
import { ReactComponent as HeartIcon } from '@assets/heart-icon-with-circle.svg';
import { ReactComponent as CancerIcon } from '@assets/cancer-icon-with-circle.svg';
import { Box } from '@components';

export const StyledResultsDeliveredContainer = styled(Box, {
  display: 'flex',
  flexDirection: 'column',
  gap: '16px',
});

export const StyledDiseasesCardsContainer = styled(Box, {
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between',
  marginTop: '25px',
});

export const StyledColonIcon = styled(ColonIcon, {});
export const StyledHeartIcon = styled(HeartIcon, {});
export const StyledCancerIcon = styled(CancerIcon, {});

export const StyledFootContent = styled(Box, {
  color: '$darkGray400',
  fontSize: '$sm',
  textAlign: 'right',
});

export const StyledTitle = styled('p', {
  color: '$darkGray600',
  fontSize: '$md',
  fontWeight: '$bold',
  marginBottom: '$4',
});

export const StyledResultsPercentageText = styled('span', {
  fontSize: '$sm',
  fontWeight: '$regular',
  color: '$darkBlue400',
  lineHeight: '$4',
  textAlign: 'start',
});

export const StyledContentSeparator = styled(Box, {
  borderRight: 'solid $borderWidths$2 $seafoam500',
  height: '$9',
  margin: '0 $4',
});

export const StyledResultsPercentage = styled('span', {
  fontSize: '40px',
  fontWeight: '$regular',
  color: '$darkGray500',
  marginBottom: '$2',
});

export const StyledColumn = styled(Box, {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
});
